import ModalAddEditRegexes from "./modal-add-edit-regexes";

export default ModalAddEditRegexes;